'use client'

import { fetchAgent } from '@homeSearch/modules/fetch'
import HomeSearchInput from '@homeSearch/modules/input'
import Location from '@homeSearch/modules/location'
import HomeSearchPopup from '@homeSearch/modules/popup'
import getAgentRoute from '@plugin/searchRoute/modules/agent'
import { agentList } from '@router'
import { get, size } from 'lodash-es'
import { Suspense, useCallback } from 'react'
import useProgressRouter from '@hooks/useProgressRouter'
import useAgentListContext from '../../context'

export default function AgentSearchInputContent() {

  const { replaceRouter } = useProgressRouter()
  const { slug, searchType } = useAgentListContext()

  const searchHandle = useCallback(({ suburbs, surrounding }) => {
    if (!size(suburbs)) return

    const agentRoute = getAgentRoute()
    agentRoute.setSuburbs(suburbs)
    agentRoute.surround = surrounding
    const newSlug = agentRoute.toSlug()
    if (newSlug === slug) return

    const route = agentList(get(searchType, 'route'), newSlug)
    replaceRouter(route)
  }, [searchType, replaceRouter, slug])

  return (
    <Suspense>
      <HomeSearchInput onSearch={searchHandle} placeholder='Type a suburb, city or agent’s name' mobilePlaceholder='Type a suburb, city or agent’s name'>
        <HomeSearchPopup fetcher={fetchAgent}></HomeSearchPopup>
      </HomeSearchInput>
      <Location></Location>
    </Suspense>
  )
}